import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation, fromFocus } from 'store/selectors';
import {
  changeGuestFirstName,
  changeGuestLastName,
  changeGuestEmail,
  changeGuestSpecialNeeds,
  changeGuestExtra,
  changeGuestDateOfBirth,
  changeGuestDocumentNumber,
  changeGuestDocumentExpiryDate,
  changeIcePhoneNumber,
  setFocus,
  clearFocus,
  moveFocus,
  setRequiredField,
  unsetRequiredField,
  setValidationError,
  unsetValidationError,

} from 'store/actions';

import { GuestInput } from 'components';

const GuestInputContainer = props => <GuestInput {...props} />;

const mapFieldToAction = {
  firstName: changeGuestFirstName,
  lastName: changeGuestLastName,
  email: changeGuestEmail,
  disabilityCode: changeGuestSpecialNeeds,
  loyaltyNumber: changeGuestExtra,
  dateOfBirth: changeGuestDateOfBirth,
  documentNumber: changeGuestDocumentNumber,
  documentExpiryDate: changeGuestDocumentExpiryDate,
  icePhoneNumber: changeIcePhoneNumber,
};
const translateField = (field) => {
  const foo = ['email', 'documentNumber', 'icePhoneNumber'];
  if (foo.includes(field)) {
    return `${field}Label`;
  }
  if (field === 'loyaltyNumber') {
    return 'extraLabel';
  }
  return field;
};

const mapStateToProps = (state, { guestId, field, departureId, trackFocus }) => {
  if (!mapFieldToAction[field]) throw new Error(`Unsupported field: ${field}`);
  const currentFocus = fromFocus.getFocus(state);

  return {
    value: fromReservation.getGuest(state, guestId)[field] || '',
    shouldFocus: !!trackFocus && currentFocus.guestId === guestId && currentFocus.field === field && currentFocus.departureId === departureId,
    readonly: fromReservation.isCheckInStarted(state, departureId),
  };
};
const mapDispatchToProps = (dispatch, { guestId, field, departureId, trackFocus }) => ({
  onChange: value => dispatch(mapFieldToAction[field](guestId, value)),
  onFocus: () => trackFocus && dispatch(setFocus(guestId, field, departureId)),
  onBlur: () => trackFocus && dispatch(clearFocus()),
  onMove: direction => trackFocus && dispatch(moveFocus(direction)),
  setRequiredField: () => dispatch(setRequiredField(guestId, field)),
  unsetRequiredField: () => dispatch(unsetRequiredField(guestId, field)),
  setValidationError: () => dispatch(setValidationError(guestId, translateField(field))),
  unsetValidationError: () => dispatch(unsetValidationError(guestId, translateField(field))),
});

GuestInputContainer.propTypes = {
  guestId: PropTypes.string.isRequired,
  departureId: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  trackFocus: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(GuestInputContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestInput.js